import States from './States.jsx';

export default function AddAdditionalState(additionalState) {
  let states = States();

  states = states.concat(additionalState);
  return  states.sort((a, b) => (a.label > b.label) ? 1 : ((a.label < b.label) ? -1 : 0));
}